import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20style%20abstract%20illustration%2C%20warm%20gradient%20background%20with%20subtle%20comic%20panel%20lines%2C%20soft%20golden%20and%20coral%20tones%2C%20modern%20digital%20art%20aesthetic%2C%20clean%20minimal%20composition%2C%20editorial%20quality%2C%20no%20text%2C%20atmospheric%20warm%20lighting%2C%20smooth%20gradient%20transition%2C%20contemporary%20webtoon%20cover%20style%20backdrop&width=1920&height=900&seq=hero-bg-home&orientation=landscape"
          alt="韩漫星球Hero背景"
          className="w-full h-full object-cover object-top"
          title="韩漫星球 - 韩国漫画在线免费阅读"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-5 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <p className="inline-block px-4 py-1.5 rounded-full border border-background-50/30 text-background-50 text-sm mb-6 backdrop-blur-sm whitespace-nowrap">
              <i className="ri-sparkling-line mr-2"></i>
              国内领先的韩漫在线免费阅读平台
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-6">
              探索最全的{' '}
              <em className="text-primary-400 not-italic">韩国漫画</em>
              <br />
              尽在韩漫星球
            </h1>
            <p className="text-background-50/80 text-sm md:text-base max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed">
              收录超过3200部韩国漫画作品，涵盖恋爱、奇幻、悬疑、都市等多种类型。
              全部免费阅读，每日更新，为你提供极致的下拉式韩漫阅读体验。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/hot"
                className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm font-medium cursor-pointer transition-colors inline-flex items-center gap-2"
              >
                <i className="ri-fire-line"></i>
                热门连载
              </Link>
              <Link
                to="/category/all"
                className="whitespace-nowrap border border-background-50/40 text-background-50 hover:bg-background-50/10 px-8 py-3 rounded-full text-sm font-medium cursor-pointer transition-colors inline-flex items-center gap-2"
              >
                <i className="ri-grid-line"></i>
                浏览全部
              </Link>
            </div>
            <div className="flex items-center gap-6 mt-8 justify-center lg:justify-start">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-background-50">3200+</p>
                <p className="text-xs text-background-50/60">收录韩漫</p>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-background-50">850万+</p>
                <p className="text-xs text-background-50/60">活跃读者</p>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-background-50">99.8%</p>
                <p className="text-xs text-background-50/60">好评率</p>
              </div>
            </div>
          </div>

          <div className="hidden lg:block flex-1">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20mobile%20reading%20showcase%2C%20smartphone%20displaying%20colorful%20comic%20art%2C%20clean%20minimal%20product%20photography%20style%2C%20warm%20atmospheric%20lighting%2C%20floating%20composition%2C%20modern%20tech%20aesthetic%2C%20editorial%20quality%2C%20isolated%20on%20transparent%20background&width=800&height=1000&seq=hero-showcase&orientation=portrait"
              alt="韩漫阅读展示"
              className="w-full max-w-md mx-auto object-contain"
              title="韩漫星球阅读体验展示"
            />
          </div>
        </div>
      </div>
    </section>
  );
}